import React, { Component } from 'react';
import {
    Container,
    Button,
    Row, Col
} from 'reactstrap';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faStar
} from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons'
import CollapseCard from '../../components/CollapseCard/CollapseCard';
import PermissionWrapper from '../../auth/PermissionWrapper';
import CompanyContext from '../../auth/CompanyContext';
import CreateAdvisor from '../demographics/CreateAdvisor';

class Companies extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);

        this.path = String(this.props.location.pathname).split('/')[2];

        this.state = {
            isLoading: true,
            companies: [],
            selectedRow: null,
            modalOpen: this.props?.location?.state?.modalOpen || false,
            scrollYBeforeModal: 0,
            reactTablePage: 0,
            reactTablePageSize: 50,
            reactTableSorted: [],
            reactTableFiltered: []
        };

        this.companyColumns = [
            {
                Header: <FontAwesomeIcon icon={faStar} />,
                accessor: 'favorites',
                filterable: false,
                width: 60,
                Cell: row =>
                    parseInt(row.original.favorites) > 0 ? (
                        <FontAwesomeIcon
                            icon={faStar}
                            className="favoriteIcon"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.props.removeFavorite('sec', row.original.sec, this.favoriteCallback);
                            }}
                        />
                    ) : (
                        <FontAwesomeIcon
                            icon={faStarOutline}
                            className="favoriteIconDisabled"
                            onClick={(e) => {
                                e.stopPropagation();
                                this.props.addFavorite('sec', row.original.sec, this.favoriteCallback);
                            }}
                        />
                    )
            },
            {
                Header: 'SEC#',
                accessor: 'sec',
                id: 'SEC',
                width: 100,
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod,
                Cell: (props) => (
                    <Link to={{ pathname: `/demographics/${props.value}`, state: {} }} style={{ marginRight: '8px' }}>
                        {props.value}
                    </Link>
                )
            },
            {
                Header: 'Company Name',
                accessor: 'primaryBusinessName',
                id: 'Company Name',
                width: 300,
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod
            },
            {
                Header: 'Website',
                accessor: 'website',
                id: 'Website',
                width: 300,
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod,
                Cell: ({ value }) =>
                    value ? (
                        <a href={/^https?:\/\//i.test(value) ? value : `http://${value}`} target="_blank" rel="noopener noreferrer">
                            {value}
                        </a>
                    ) : null
            },
            {
                Header: 'Address',
                id: 'Address',
                // string used for sort/filter; custom Cell below for formatting
                accessor: d => {
                    const line2 = d.address2 ? ` | ${d.address2}` : '';
                    const cityState = [d.city, d.state].filter(Boolean).join(', ');
                    const zip = d.postalCode ? ` ${d.postalCode}` : '';
                    return [d.address1, line2 && d.address2, cityState && cityState + zip].filter(Boolean).join(' | ');
                },
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod,
                Cell: ({ original }) => (
                    <>
                        {original.address1}
                        {original.address2 && <><br />{original.address2}</>}
                        {(original.city || original.state || original.postalCode) && (
                            <>
                                <br />
                                {original.city}{original.city && original.state ? ', ' : ''}{original.state} {original.postalCode}
                            </>
                        )}
                    </>
                )
            },
            {
                Header: 'Phone',
                accessor: 'phone',
                id: 'Phone',
                width: 140,
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod
            },
            {
                Header: 'Organization CRD',
                accessor: 'organizationCRD',
                id: 'Organization CRD',
                width: 180,
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod
            },
            {
                Header: 'Company Type',
                accessor: 'companyType',
                id: 'Company Type',
                width: 180,
                filterable: true,
                filterMethod: this.noBlanksFilterMethod,
                sortMethod: this.sortMethod
            },
        ];
    }

    componentDidMount = () => {
        this.getCompanies(() => {
            if (this.path) {
                this.handleRowClick(this.state.companies[0], null)
            }
        });
    }

    getAttributeValues = (attrs, name) => {
        if (!attrs) return [];
        // attrs might be a JSON string or already parsed
        const arr = Array.isArray(attrs) ? attrs : (typeof attrs === 'string' ? (() => { try { return JSON.parse(attrs) } catch { return [] } })() : []);
        return arr
            .filter(x => x && String(x.attribute).toLowerCase() === String(name).toLowerCase())
            .map(x => x.value)
            .filter(v => v != null && String(v).trim() !== '');
    };

    parseNdjsonStream = async ({ response, onRow, signal }) => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let leftover = "";

        while (true) {
            if (signal?.aborted) break;
            const { value, done } = await reader.read();
            if (done) break;

            const chunk = decoder.decode(value, { stream: true });
            const text = leftover + chunk;
            const lines = text.split("\n");
            leftover = lines.pop() || ""; // save last partial line

            for (const line of lines) {
                const trimmed = line.trim();
                if (!trimmed) continue;
                try {
                    const obj = JSON.parse(trimmed);
                    if (onRow) onRow(obj);
                } catch {
                    // ignore malformed lines (or log)
                }
            }
        }

        // flush any final full line
        const tail = leftover.trim();
        if (tail) {
            try {
                const obj = JSON.parse(tail);
                if (onRow) onRow(obj);
            } catch { }
        }
    };

    toggleModal = () => {
        const closing = this.state.modalOpen;
        this.setState((prev) => {
            return {
                modalOpen: !closing,
                companies: closing ? [] : prev.companies
            }
        }, () => {
            if (closing) {
                setTimeout(() => {
                    window.scrollTo({ top: this.state.scrollYBeforeModal });
                }, 0);
            }
        });
    };

    favoriteCallback = (data) => {
        let items = [...this.state.companies];
        items.forEach(result => {
            result['favorites'] = ("company" in data && data.sec.findIndex(item => item.Favorite === result['sec']) > -1) ? 1 : '';
        })
        this.setState({
            items: items
        })
    }

    handleRowClick = (row, event) => {
        // Prevent modal from opening if clicking on a Link
        if (event?.target?.tagName === "A") return;
        const currentScrollY = window.scrollY;
        // console.log('row', row)
        this.setState({
            scrollYBeforeModal: currentScrollY,
            selectedRow: row,
            // companies: row.companies,
            // modalOpen: true
        }, () => {
            window.scrollTo({ top: 0 });
            // this.handleEditSwap(row.sec);
        });
    };

    noBlanksFilterMethod = (filter, row) => {
        const filterValue = filter.value.toLowerCase().trim();
        const cellValue = row[filter.id];

        // If filterValue is empty (no search input), show all records
        if (!filterValue) return true;

        // If cellValue is empty or blank, do not show it when filtering
        if (!cellValue || cellValue.toString().trim() === '') return false;

        // If cellValue is an array, check each name inside
        if (Array.isArray(cellValue)) {
            return cellValue.some(company => {
                const name = company?.toLowerCase().trim() || '';
                return name.includes(filterValue);
            });
        }

        // For normal text values, apply filter
        return cellValue.toString().toLowerCase().includes(filterValue);
    }

    sortMethod = (a, b) => {
        const valA = a ? a.toString().toLowerCase().trim() : "";
        const valB = b ? b.toString().toLowerCase().trim() : "";

        if (valA === "" && valB !== "") return 1;
        if (valB === "" && valA !== "") return -1;

        return valA.localeCompare(valB);
    }

    componentWillUnmount() {
        // if (this.abortController) {
        //   this.abortController.abort();
        // }
        // your existing override is fine to silence setState after unmount
        this.setState = () => { };
    }

    getCompanies = async (cb) => {
        if (this.abortController) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();

        this.setState({ isLoading: true, companies: [] },
            async () => {
                const headers = {
                    'Accept': 'application/x-ndjson',   // <-- tell server we want NDJSON
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                };

                // NB: do NOT set 'Content-Type' on a GET
                const resp = await fetch(`/api/companies/${this.props.user}`, {
                    method: 'GET',
                    headers,
                    signal: this.abortController.signal
                });

                if (!resp.ok || !resp.body) {
                    this.setState({ isLoading: false });
                    return;
                }

                // batch rows to avoid re-render per row
                const buffer = [];
                let raf = null;
                const flush = () => {
                    if (!buffer.length) return;
                    this.setState(prev => ({ companies: prev.companies.concat(buffer.splice(0)) }));
                    raf = null;
                };

                await this.parseNdjsonStream({
                    response: resp,
                    signal: this.abortController.signal,
                    onRow: (row) => {
                        // normalize attributes to an array
                        // if (typeof row.attributes === 'string') {
                        //   try { row.attributes = JSON.parse(row.attributes); } catch { row.attributes = []; }
                        // } else if (!Array.isArray(row.attributes)) {
                        //   row.attributes = [];
                        // }

                        // // derive Company Type (dedupe; join)
                        // const types = this.getAttributeValues(row.attributes, 'Company Type');
                        // const unique = Array.from(new Set(types.map(t => String(t))));
                        // row.companyType = unique.join(', '); // empty string if none

                        buffer.push(row);
                        if (!raf) raf = requestAnimationFrame(flush);
                    }
                });

                if (buffer.length) this.setState(prev => ({ companies: prev.companies.concat(buffer.splice(0)) }));

                this.setState({ isLoading: false }, () => cb && cb());
            }
        );


    };

    addCompany = () => {
        fetch('/api/demographics/', {
            method: 'POST',
            body: JSON.stringify(this.state),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then((results) => {
                if (results.success) {
                    localStorage.setItem('demographicsActiveTab', 2)
                    this.props.history.push({
                        pathname: `/demographics/${results.data}`,
                        // state: {

                        // }
                    });
                }
            })
    }

    handleEditSwap = (val) => {
        this.toggleModal();
    }

    render() {
        return (
            <PermissionWrapper {...this.props} allowedPermission="Companies">
                <Container fluid className='pz-0'>
                    {!this.path && !this.state.modalOpen && <Row>
                        <Col md={3} className='text-left pt-3 pl-5'>
                        </Col>
                        <Col md={6} className='text-center'>
                            <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                                <h1>Companies</h1>
                            </PermissionWrapper>
                        </Col>
                        <Col md={3} className="text-right pt-4 pr-4">
                            <Button
                                color="primary"
                                onClick={this.addCompany}
                            >
                                Add Company
                            </Button>
                        </Col>
                    </Row>}
                    {this.state.modalOpen &&
                        <>
                            <Row className='align-items-start'>
                                <Col md={3} className='text-left pt-3 pl-5'>
                                </Col>
                                <Col md={6} className='text-center'>
                                    <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                                        <h1>Add Company</h1>
                                    </PermissionWrapper>
                                </Col>
                                <Col md={3} className="text-right pt-4 pr-4">
                                    <Button
                                        color="primary"
                                        onClick={() => this.setState({ modalOpen: false })}
                                    >
                                        Return to Companies List
                                    </Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <CreateAdvisor {...this.props} />
                                </Col>
                            </Row>
                        </>}
                    {!this.state.modalOpen &&
                        <CollapseCard title={`Companies (${this.state.companies.length})`} open={true}>
                            <ReactTable
                                data={this.state.companies}
                                columns={this.companyColumns}
                                pageSize={50}
                                page={this.state.reactTablePage}
                                sorted={this.state.reactTableSorted}
                                filtered={this.state.reactTableFiltered}
                                onPageChange={(pageIndex) => this.setState({ reactTablePage: pageIndex })}
                                onPageSizeChange={(pageSize, pageIndex) => this.setState({ reactTablePageSize: pageSize, reactTablePage: pageIndex })}
                                onSortedChange={(newSorted) => this.setState({ reactTableSorted: newSorted })}
                                onFilteredChange={(filtered) => this.setState({ reactTableFiltered: filtered })}
                                showPagination={true}
                                defaultSorted={[{ id: "Company Name", desc: false }]}
                                getTrProps={(state, rowInfo) => {
                                    if (!rowInfo) return {};

                                    return {
                                        onClick: (event) => this.handleRowClick(rowInfo.original, event),
                                        style: {
                                            cursor: "pointer"
                                        }
                                    };
                                }}
                            />
                        </CollapseCard>}
                </Container>
            </PermissionWrapper>
        );
    }
}

export default Companies;
